<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <custom-modal
        title="Create Unit"
        @onSubmit="saveUnit"
        @onClose="show = false"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="name"
                vid="name"
                rules="required"
              >
                <v-text-field
                  :error-messages="errors"
                  required
                  dense
                  label="Name"
                  v-model="newUnit.name"
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Shortname"
                vid="sortform"
                rules="required"
              >
                <v-text-field
                  :error-messages="errors"
                  required
                  dense
                  label="Shortname"
                  v-model="newUnit.sortform"
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import FileUpload from '@/components/base/FileUpload';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

extend('min', (value) => {
  if (value && value.length >= 3) {
    return true;
  }
  return 'Please enter above three characters';
});

export default {
  data: () => ({
    selectedImages: '',
    show: false,

    newUnit: {
      name: '',
      sortform: '',
    },
    value: [],
    options: [],
    isLoading: false,
  }),

  name: 'AddUnit',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FileUpload,
  },

  methods: {
    async saveUnit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.isLoading = true;
        this.CreateUnit();
      }
    },
    CreateUnit() {
      let Unitname = this.newUnit;
      this.isLoading = true;

      this.$store
        .dispatch('Unit/CreateUnit', Unitname)
        .then((res) => {
          this.$toast.success('Unit created successfully');
          // this.refreshDataUnit();
          this.$emit('afterSave');

          this.$refs.observer.reset();
          this.isLoading = false;
          this.show = false;

          this.newUnit = {};
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('Failed to create unit');
          this.messages = err.data.title;
          this.isLoading = false;
          this.show = false;
        });
    },
    openModal() {
      this.show = true;
      this.newUnit = {};
    },
  },
};
</script>
